module.exports = __webpack_public_path__ + "static/media/nodatafound.26653d57.webp";